import waRequest from './wa-request';

export const apiBase = '/person-group/v2';

function searchPersonGroups(config) {
  const {
    params: {page = 0, size = 25, sort},
    data,
  } = config;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/searches`,
    method: 'post',
    params: {
      page,
      size,
      sort,
    },
    data,
  });
}

function getPersonGroupById({pathParams: {groupId}, signal}) {
  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/${groupId}`,
    method: 'get',
    signal,
  });
}

function searchPersonGroupPeople(config) {
  const {
    pathParams: {groupId},
    params: {includeDetails, locale, page, size, sort},
    data,
    signal,
  } = config;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/${groupId}/persons/searches`,
    method: 'post',
    params: {
      includeDetails,
      locale,
      page,
      size,
      sort,
    },
    data,
    signal,
  });
}

/**
 * Initiate authenticated POST /person-group/v2/person-groups
 *
 * @param data {Object} containing name, organizationId, and description
 * @param sourceId {uuid} optional - groupId if duplicating an existing group
 * @returns {Promise}
 */
function addPersonGroup({data, signal}) {
  const {sourceId, ...rest} = data;

  const {name, organizationId, description} = rest;

  const params = sourceId ? {sourceId} : null;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups`,
    method: 'post',
    params,
    data: {name, organizationId, description},
    signal,
  });
}

function deletePersonGroup({pathParams: {groupId}, signal}) {
  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/${groupId}`,
    method: 'delete',
    signal,
  });
}

function bulkDeletePersonGroups({data}) {
  const {ids, organizationIds, personIds, searchText} = data;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/deletes`,
    method: 'post',
    data: {
      ids,
      organizationIds,
      personIds,
      searchText,
    },
  });
}

function updatePersonGroup({data}, signal) {
  const {id, name, description, organizationId} = data;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/${id}`,
    method: 'put',
    data: {
      name,
      organizationId,
      description,
    },
    signal,
  });
}

function manageGroupPersonAssociations({url, params, data}) {
  return waRequest.requestAuthenticated({
    url,
    method: 'put',
    params,
    data,
  });
}

function addGroupPersonAssociations({pathParams, data}) {
  const {groupId} = pathParams;
  return manageGroupPersonAssociations({
    url: `${apiBase}/person-groups/${groupId}/persons`,
    params: {operation: 'ADD'},
    data,
  });
}

function removeGroupPersonAssociations({pathParams, data}) {
  const {groupId} = pathParams;
  return manageGroupPersonAssociations({
    url: `${apiBase}/person-groups/${groupId}/persons`,
    params: {operation: 'DELETE'},
    data,
  });
}

function addGroupsPersonsAssociations({data}) {
  return manageGroupPersonAssociations({
    url: `${apiBase}/person-groups/persons`,
    params: {operation: 'ADD'},
    data,
  });
}

function removeGroupsPersonsAssociations({data}) {
  return manageGroupPersonAssociations({
    url: `${apiBase}/person-groups/persons`,
    params: {operation: 'DELETE'},
    data,
  });
}

function getGroupsPersons(params) {
  const {
    params: {includeDetails, locale, page, size, sort},
    data,
    signal,
  } = params;

  const {ids, organizationIds, personIds, searchText} = data;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/persons/searches`,
    method: 'post',
    params: {
      includeDetails,
      locale,
      page,
      size,
      sort,
    },
    data: {ids, organizationIds, personIds, searchText},
    signal,
  });
}

function initiateGroupPersonExport({params, pathParams, data}) {
  const {
    organizationId,
    locale,
    createUrl,
    sort,
    accountInfo,
    includeOrganizations,
    addresses,
    emails,
    emergencyContacts,
    identifiers,
    names,
    phones,
    optionalFields,
    mobileLocations,
    includePersonTypes,
    tripSegments,
    includeExpatriations,
    includeSites,
  } = params;

  return waRequest.requestAuthenticated({
    url: `${apiBase}/person-groups/${pathParams.groupId}/exports`,
    method: 'post',
    params: {
      organizationId,
      locale,
      createUrl,
      sort,
      accountInfo,
      includeOrganizations,
      addresses,
      emails,
      emergencyContacts,
      identifiers,
      names,
      phones,
      optionalFields,
      mobileLocations,
      includePersonTypes,
      tripSegments,
      includeExpatriations,
      includeSites,
    },
    data,
  });
}

export default {
  searchPersonGroups,
  getPersonGroupById,
  searchPersonGroupPeople,
  addPersonGroup,
  deletePersonGroup,
  bulkDeletePersonGroups,
  updatePersonGroup,
  addGroupPersonAssociations,
  addGroupsPersonsAssociations,
  removeGroupPersonAssociations,
  removeGroupsPersonsAssociations,
  getGroupsPersons,
  initiateGroupPersonExport,
};
